import underscored from 'underscore.string/underscored';

angular.module('gym.components').directive('bluefinPaymentDetails', function() {
  return {
    restrict: 'EA',
    scope: {
      paymentMethods: '=',
      permissions: '=',
      contact: '=',
      remove: '&',
      setDefault: '&'
    },
    template: require('templates/components/contacts/wallet/bluefin_payment_details.html.slim'),
    controller: ["$scope", "AdminUserService", function($scope, AdminUserService) {
      $scope.adminHasPermission = AdminUserService.has;
      return $scope.contactsType = function(type) {
        return `${underscored(type)}s`;
      };
    }]
  };
});
